import { Component } from 'react'

export default class TermsAndConditions extends Component {
    render() {
        return (
            <div>TermsAndConditions</div>
        )
    }
}
